import { useLocation } from 'react-router-dom';
import uuid from 'react-uuid';
import { t } from 'i18next';
import { Button } from '@peacecover/component';
import initializePortOne from '../../utils/PortOne';
import StickyHeader from '../components/bar/StickyHeader';

const IdentityVerificationIntroPage = () => {
  const location = useLocation();
  const currentQueryParams = new URLSearchParams(location.search);
  const type = currentQueryParams.get('type');
  const handleRequestIdentityVerification = () => {
    const IMP = initializePortOne();
    const { origin, pathname, search } = window.location;

    IMP.certification({
      merchant_uid: `imp-${uuid()}`,
      min_age: 14,
      company: '포카판',
      popup: false,
      m_redirect_url: `${origin}/identity-verification/callback?redirect_path=${encodeURIComponent(
        pathname + search
      )}`
    });
  };

  const title =
    type === 'invite' ? t('IdentityVerification.inviteTitle') : t('IdentityVerification.title');

  return (
    <div className="min-h-screen pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] bg-background-light dark:bg-background-dark">
      <StickyHeader showBackButton={true} onClickBackButton={() => window.close()} />
      <div className="h-screen flex flex-col items-center justify-center gap-[30px]">
        <img
          src="/assets/icons/verfied.graphic.png"
          alt="verfied.graphic"
          className="w-[82px] h-[82px]"
        />
        <h1 className="text-[26px] font-bold text-text-main-lv1 leading-[31px] whitespace-pre-line text-center">
          {title}
        </h1>
      </div>
      <div className="fixed bottom-0 left-0 right-0 px-[24px] pb-[calc(env(safe-area-inset-bottom)+10px)]">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold leading-[20px] rounded-[18px]"
          onClick={handleRequestIdentityVerification}
        >
          {t('next')}
        </Button>
      </div>
    </div>
  );
};

export default IdentityVerificationIntroPage;
